module.exports = __webpack_public_path__ + "static/media/right_banner.89f5ce2f.svg";